import { render, staticRenderFns } from "./EmployeeNew.vue?vue&type=template&id=8bfd6492&scoped=true"
import script from "./EmployeeNew.vue?vue&type=script&lang=js"
export * from "./EmployeeNew.vue?vue&type=script&lang=js"
import style0 from "./EmployeeNew.vue?vue&type=style&index=0&id=8bfd6492&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfd6492",
  null
  
)

export default component.exports